import { useLocation } from 'react-router-dom';

import { ErrorBoundary } from '@/components/layout/ErrorBoundary';
import { Page } from '@/components/layout/Page';
import { ForecastExplorerContainer } from '@/features/forecasts/components/explorer/ForecastExplorerContainer';

export function ForecastExplorer() {
  const location = useLocation();

  return (
    <Page subheader="Discover your Finegrain Forecast Details">
      <ErrorBoundary locationKey={location.key} component="ForecastExplorer">
        <ForecastExplorerContainer />
      </ErrorBoundary>
    </Page>
  );
}
